import React from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";
import CommonView, { CommonViewProps } from "../../../../components/CommonView/CommonView";
import { Typography } from "antd";
const { Title, Text } = Typography;

const HolidayList = () => {
    const [selectedId, setSelectedId] = React.useState(null);
    const config: MasterConfigs = {
        api: () => '/holiday-list',
        title: 'Holiday List',
        modalTitle: () => config.title,
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Code',
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: '50%',
                ellipsis: true
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
        ],
        actions: [{ actionType: 'Add', name: 'Add' }]
    }

    const holidayList: MasterConfigs = {
        api: () => '/holiday/' + selectedId,
        title: 'Holiday List',
        modalTitle: () => holidayList.title,
        actions: [{ actionType: 'Add', name: 'Add' }],
        isActionTab: true,
        onRefresh: () => setSelectedId(null),
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Date',
                dataIndex: 'holidayOn',
                key: 'holidayOn',
                render: (text) => {
                    return new Date(text).toDateString()
                }
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: 600,
                ellipsis: true
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Date',
                name: 'holidayOn',
                type: 'date',
                rules: [{ required: true, message: 'Please select Date' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
            {
                span: 8,
            },
            {
                label: 'File',
                name: 'file',
                type: 'file',
                span: 8,
            }
        ],
    }


    const commonViewProps: CommonViewProps = {
        config: config,
        componentConfig: {
            title: 'Holiday List',
            subTitle: 'List of all holidays',
            cardTitle: 'Holiday',
            buttonName: 'Add Holiday',
            emptyDescription: 'No holidays found',
            renderComponent: (record) => <MasterComponent config={holidayList} />,
            renderListItem: (item) => {
                return <>
                    <Title level={5} style={{ lineHeight: 1.2, marginBottom: 0 }}>{item.name}</Title>
                    <Text type="secondary">{item?.code}</Text>
                </>
            },
            selectedItemId: (id) => setSelectedId(id)
        }
    }

    return <CommonView {...commonViewProps} />
}

export default HolidayList; 